// Lightweight analytics shim.
// Phase 1: events are logged to console.
// Later: wire to Google Analytics, Meta Pixel, LinkedIn Insight Tag, or Zoho SalesIQ.

export function trackEvent(name, props = {}) {
  if (typeof window === "undefined") return;
  const payload = { event: name, ...props, ts: new Date().toISOString() };
  console.debug("[analytics]", payload);

  // PostHog is preloaded in index.html ,  forward events if available.
  if (window.posthog && typeof window.posthog.capture === "function") {
    try {
      window.posthog.capture(name, props);
    } catch {
      /* noop */
    }
  }
}

export const ANALYTICS_EVENTS = {
  CTA_CLICKED: "cta_clicked",
  COURSE_SEARCHED: "course_searched",
  CATEGORY_SELECTED: "category_selected",
  COURSE_ENQUIRY_OPENED: "course_enquiry_opened",
  FORM_SUBMITTED: "form_submitted",
  CORPORATE_ENQUIRY_SUBMITTED: "corporate_enquiry_submitted",
  CONTACT_FORM_SUBMITTED: "contact_form_submitted",
  COURSE_PATHWAY_FOCUSED: "course_pathway_focused",
};
